export class EmailTemplateEdit
{
    public id = null;
    public content: string;
    public mimeType: string;
    public mimeTypeCode: string;
    public name: string;
    public type: string;
    public typeCode: string;
    public language: string;
    public createdBy: string;
    public lastModifiedBy: string;
    public lastModifiedDate: Date;
}

export interface EmailTemplateList
{
    id: number;
    name: string;
    mimeType: string;
    type: string;
    language: string;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
